import { render, staticRenderFns } from "./ContactContactsComponent.vue?vue&type=template&id=6c2b0542"
import script from "./ContactContactsComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactContactsComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2b0542')) {
      api.createRecord('6c2b0542', component.options)
    } else {
      api.reload('6c2b0542', component.options)
    }
    module.hot.accept("./ContactContactsComponent.vue?vue&type=template&id=6c2b0542", function () {
      api.rerender('6c2b0542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactContacts/ContactContactsComponent.vue"
export default component.exports